import type { IconNode } from '../types';

/**
 * @name panda
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTEuMjUgMTcuMjVoMS41TDEyIDE4eiIgLz4KICA8cGF0aCBkPSJtMTUgMTIgMiAyIiAvPgogIDxwYXRoIGQ9Ik0xNy45MDIgNi41OTlhOCA4IDAgMCAwLS41LS41IiAvPgogIDxwYXRoIGQ9Ik0yIDE0LjVDMiAxOS40NyA2LjQ4IDIyIDEyIDIyczEwLTIuNTMgMTAtNy41YTEwIDEwIDAgMCAwLTEuMy00LjgzIDQuNSA0LjUgMCAxIDAtNy4wNS01LjUgOCA4IDAgMCAwLTMuMyAwIDQuNSA0LjUgMCAxIDAtNy4wNCA1LjVBMTAgMTAgMCAwIDAgMiAxNC41IiAvPgogIDxwYXRoIGQ9Ik02LjA5OSA2LjU5OWE4IDggMCAwIDEgLjUtLjUiIC8+CiAgPHBhdGggZD0ibTkgMTItMiAyIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/panda
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const Panda: IconNode = [
  ['path', { d: 'M11.25 17.25h1.5L12 18z' }],
  ['path', { d: 'm15 12 2 2' }],
  ['path', { d: 'M17.902 6.599a8 8 0 0 0-.5-.5' }],
  [
    'path',
    {
      d: 'M2 14.5C2 19.47 6.48 22 12 22s10-2.53 10-7.5a10 10 0 0 0-1.3-4.83 4.5 4.5 0 1 0-7.05-5.5 8 8 0 0 0-3.3 0 4.5 4.5 0 1 0-7.04 5.5A10 10 0 0 0 2 14.5',
    },
  ],
  ['path', { d: 'M6.099 6.599a8 8 0 0 1 .5-.5' }],
  ['path', { d: 'm9 12-2 2' }],
];

export default Panda;
